module.exports = __webpack_public_path__ + "static/fisherman-two-fish.de483e36.png";


//////////////////
// WEBPACK FOOTER
// ./~/@fishrmn/fishrmn-components/build/components/molecules/FishermanIcon/fisherman-two-fish.png
// module id = 1034
// module chunks = 168707334958949